// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant-conversation {
  position: relative;
  grid-area: 1/1/-1/-1;
  height: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--lkfr-ink, #232737);
  background: #f7f8fa;
  font-family: inherit;
  text-align: left;
  letter-spacing: normal;
  word-spacing: normal;
}
.assistant-conversation button, .assistant-conversation input, .assistant-conversation select, .assistant-conversation textarea {
  font: inherit;
}
.assistant-conversation button {
  cursor: pointer;
}
.assistant-conversation button:disabled {
  opacity: 0.45;
  cursor: default;
}
.assistant-conversation :is(button, summary, textarea):focus-visible {
  outline: 3px solid #5365cc;
  outline-offset: 3px;
}
.assistant-conversation svg {
  flex-shrink: 0;
}

.assistant-conversation-head {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--lkfr-border, #e4e8ee);
  background: white;
}

.assistant-feedback-navigation {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px 16px;
  padding: 2px 16px;
  background: white;
  border-bottom: 1px solid #e4e8ee;
}
.assistant-feedback-navigation button {
  min-height: 40px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  font-size: 12px;
  color: #a82540;
}

.assistant-response-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
}

.assistant-rate {
  min-height: 36px;
  border: 0;
  border-radius: 8px;
  padding: 6px 8px;
  background: #fff0f3;
  color: #a82540;
  font-size: 12px !important;
}

.assistant-message-heading {
  flex-wrap: wrap;
}

.assistant-heading {
  flex: 1 1;
  min-width: 0;
}
.assistant-heading h1 {
  font-size: 20px;
  line-height: 1.2;
  margin: 0;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.assistant-heading p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.3;
  color: var(--lkfr-muted, #657085);
}

.assistant-conversation .assistant-heading h1 {
  font-size: 20px;
  line-height: 1.2;
  margin: 0;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.assistant-avatar, .assistant-intro-icon {
  display: grid;
  place-items: center;
  border-radius: 14px;
  color: var(--lkfr-accent, #e72f44);
  background: var(--lkfr-accent-soft, #fff0f2);
  flex-shrink: 0;
}

.assistant-avatar {
  width: 40px;
  height: 40px;
}
.assistant-avatar svg {
  width: 24px;
  height: 24px;
}

.assistant-icon-button, .assistant-new {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 12px;
  background: white;
  color: inherit;
}

.assistant-icon-button {
  width: 40px;
  flex-shrink: 0;
}

.assistant-new {
  padding: 0 12px;
  font-size: 12px !important;
}
.assistant-new svg {
  width: 18px;
  height: 18px;
}

.assistant-context {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding: 12px 24px;
  border: 0;
  border-bottom: 1px solid var(--lkfr-border, #e4e8ee);
  background: white;
  color: inherit;
  text-align: left;
}

.assistant-context-icon {
  color: var(--lkfr-muted, #657085);
}
.assistant-context-icon svg {
  display: block;
  width: 20px;
  height: 20px;
}

.assistant-context-text {
  flex: 1 1;
  min-width: 0;
}
.assistant-context-text strong {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 500;
}
.assistant-context-text small {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: var(--lkfr-muted, #657085);
}

.assistant-context-edit {
  font-size: 12px;
  color: var(--lkfr-muted, #657085);
}

.assistant-context > svg {
  width: 16px;
  color: var(--lkfr-muted, #657085);
}

.assistant-messages {
  position: relative;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 28px 24px;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.assistant-intro {
  width: min(100%, 600px);
  margin: auto;
  padding: 14px 0;
  text-align: center;
}

.assistant-intro-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 18px;
}
.assistant-intro-icon svg {
  width: 31px;
  height: 31px;
}

.assistant-intro h2 {
  font-size: 27px;
  line-height: 1.2;
  font-weight: 600;
  margin: 0 0 12px;
  letter-spacing: -0.035em;
}

.assistant-intro > p {
  max-width: 440px;
  margin: 0 auto;
  font-size: 14px;
  color: var(--lkfr-muted, #657085);
  line-height: 1.6;
}

.assistant-prompts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 24px 0 16px;
  text-align: left;
}

.assistant-prompts button {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  min-height: 84px;
  padding: 14px;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 14px;
  background: white;
  color: inherit;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;
}
.assistant-prompts button > span:nth-child(2) {
  flex: 1 1;
  min-width: 0;
}
.assistant-prompts button strong {
  display: block;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
}
.assistant-prompts button small {
  display: block;
  margin-top: 5px;
  color: var(--lkfr-muted, #657085);
  font-size: 11px;
  line-height: 1.35;
}
.assistant-prompts button:hover:not(:disabled) {
  border-color: rgba(231, 47, 68, 0.3764705882);
  background: #fffafb;
}

.assistant-prompt-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #f3f5f8;
  color: #627086;
}
.assistant-prompt-icon svg {
  width: 20px;
  height: 20px;
}

.assistant-prompt-arrow {
  color: #8590a2;
  font-size: 15px;
}

.assistant-about {
  font-size: 11px;
  color: var(--lkfr-muted, #657085);
}
.assistant-about summary {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  cursor: pointer;
}
.assistant-about p {
  font-size: 12px;
  line-height: 1.55;
  text-align: left;
  padding: 12px 14px;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 12px;
  margin: 0;
  background: white;
}

.assistant-select-salon {
  margin: 20px 0 10px;
  padding: 12px 18px;
  border: 0;
  border-radius: 12px;
  background: var(--lkfr-accent, #e72f44);
  color: white;
}

.assistant-message {
  width: min(100%, 720px);
  margin: 0 auto 24px;
  overflow-wrap: anywhere;
}

.assistant-message-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.assistant-message-heading strong {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--lkfr-muted, #657085);
  font-size: 12px;
  font-weight: 500;
}
.assistant-message-heading strong svg {
  width: 17px;
  height: 17px;
  color: var(--lkfr-accent, #e72f44);
}

.assistant-message.user {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.assistant-message.user .assistant-text {
  max-width: 88%;
  background: #ffedef;
  border-color: #ffe0e5;
  border-radius: 16px 16px 4px 16px;
}

.assistant-text {
  padding: 18px 20px;
  margin: 0;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 4px 16px 16px 16px;
  background: white;
  font-size: 15px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.assistant-copy {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 4px 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--lkfr-muted, #657085);
  font-size: 11px !important;
}
.assistant-copy:hover {
  background: #eef1f5;
}

.assistant-sources {
  margin-top: 8px;
  color: var(--lkfr-muted, #657085);
  font-size: 12px;
  line-height: 1.5;
}
.assistant-sources summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  list-style: none;
}
.assistant-sources summary::-webkit-details-marker {
  display: none;
}
.assistant-sources summary svg {
  width: 14px;
  height: 14px;
}
.assistant-sources[open] summary svg {
  transform: rotate(180deg);
}
.assistant-sources > div {
  padding: 0 12px 12px;
}
.assistant-sources p {
  margin: 8px 0;
}
.assistant-sources ul {
  display: grid;
  gap: 8px;
  padding: 0;
  list-style: none;
}
.assistant-sources a {
  color: #bd213a;
  text-decoration: none;
}
.assistant-sources a:hover {
  text-decoration: underline;
}

.assistant-source-warning {
  margin: 8px 12px 0;
  font-size: 12px;
  color: #9a651c;
}

.assistant-thinking {
  display: flex;
  align-items: center;
  gap: 12px;
  width: min(100%, 720px);
  margin: 8px auto 16px;
  color: var(--lkfr-muted, #657085);
  font-size: 12px;
}

.assistant-thinking-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.assistant-thinking-dots i {
  width: 5px;
  height: 5px;
  background: #e72f44;
  border-radius: 50%;
  animation: assistant-thinking 1.3s ease-in-out infinite;
}
.assistant-thinking-dots i:nth-child(2) {
  animation-delay: 0.15s;
}
.assistant-thinking-dots i:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes assistant-thinking {
  0%, 70%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  35% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
.assistant-latest {
  position: absolute;
  bottom: 112px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  min-height: 44px;
  padding: 8px 14px;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 22px;
  box-shadow: 0 3px 15px rgba(35, 39, 55, 0.0705882353);
  background: white;
  color: inherit;
  font-size: 12px !important;
}

.assistant-error {
  flex: 0 0 auto;
  padding: 10px 20px;
  max-height: 100px;
  overflow-y: auto;
  border-top: 1px solid #ffdde3;
  background: #fff3f5;
  color: #af2135;
  font-size: 13px;
  line-height: 1.4;
}
.assistant-error button {
  min-height: 44px;
  margin-left: 8px;
  padding: 8px;
  border: 0;
  background: transparent;
  color: inherit;
  text-decoration: underline;
}

.assistant-copy-error {
  margin: 0;
  padding: 5px 20px;
  color: var(--lkfr-muted, #657085);
  font-size: 11px;
}

.assistant-composer {
  flex: 0 0 auto;
  padding: 14px 24px 12px;
  border-top: 1px solid var(--lkfr-border, #e4e8ee);
  background: white;
}

.assistant-composer-field {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: min(100%, 760px);
  margin: auto;
  padding: 6px;
  border: 1px solid #d8dee8;
  border-radius: 16px;
  background: white;
}
.assistant-composer-field:focus-within {
  border-color: #dd7180;
  box-shadow: 0 0 0 3px rgba(231, 47, 68, 0.0352941176);
}
.assistant-composer-field textarea {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  resize: none;
  min-height: 44px;
  max-height: 144px;
  border: 0;
  outline: 0 !important;
  border-radius: 10px;
  padding: 10px;
  background: transparent;
  color: inherit;
  font-size: 15px;
  line-height: 24px;
}
.assistant-composer-field textarea:disabled {
  opacity: 0.6;
}
.assistant-composer-field textarea::placeholder {
  color: #8c95a5;
}

.assistant-send {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--lkfr-accent, #e72f44);
  color: white;
}
.assistant-send svg {
  width: 22px;
  height: 22px;
}

.assistant-composer-hint {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  max-width: 760px;
  margin: 8px auto 0;
  padding: 0 5px;
  color: #8490a2;
  font-size: 10px;
  line-height: 1.4;
}

.lkfr-dialog-overlay:has(> .assistant-settings-dialog) {
  height: var(--assistant-dialog-viewport, 100dvh);
}

.lkfr-dialog.assistant-settings-dialog {
  width: min(100%, 480px);
  max-height: calc(var(--assistant-dialog-viewport, 100dvh) - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  font-family: "Cera Pro", Arial, sans-serif;
}
.lkfr-dialog.assistant-settings-dialog .lkfr-dialog-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.lkfr-dialog.assistant-settings-dialog .lkfr-dialog-heading h2 {
  margin: 0;
  font-size: 23px;
}
.lkfr-dialog.assistant-settings-dialog .lkfr-dialog-heading button {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 1px solid #e4e8ee;
  border-radius: 12px;
  background: white;
  font-size: 23px;
}

.assistant-settings {
  margin-top: 20px;
  color: #232737;
}
.assistant-settings button, .assistant-settings input, .assistant-settings select {
  font: inherit;
}
.assistant-settings > label, .assistant-settings .assistant-period label {
  display: grid;
  min-width: 0;
  gap: 7px;
  font-size: 12px;
  color: #657085;
}
.assistant-settings select, .assistant-settings input[type=date] {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 10px 12px;
  box-sizing: border-box;
  border: 1px solid #dce2eb;
  border-radius: 10px;
  background: white;
  color: #232737;
  font-size: 16px;
}
.assistant-settings fieldset {
  padding: 0;
  margin: 22px 0 0;
  border: 0;
  min-width: 0;
}
.assistant-settings legend {
  padding: 0;
  margin-bottom: 10px;
  width: 100%;
  font-size: 13px;
  font-weight: 500;
}
.assistant-settings legend span {
  float: right;
  color: #8490a2;
  font-size: 11px;
}

.assistant-period-presets {
  display: flex;
  gap: 7px;
  margin-bottom: 12px;
}
.assistant-period-presets button {
  flex: 1 1;
  min-height: 44px;
  padding: 8px 5px;
  border: 1px solid #e4e8ee;
  border-radius: 10px;
  background: #f5f7fa;
  color: #46536a;
  font-size: 12px;
  cursor: pointer;
}

.assistant-period {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.assistant-comparison > p {
  margin: 0 0 10px;
  font-size: 12px;
}

.assistant-comparison-list {
  max-height: 180px;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: grid;
  gap: 6px;
}
.assistant-comparison-list label {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 10px 12px;
  border: 1px solid #e4e8ee;
  border-radius: 10px;
  font-size: 13px;
  cursor: pointer;
}
.assistant-comparison-list input {
  appearance: auto;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  accent-color: #e72f44;
}
.assistant-comparison-list label:has(input:checked) {
  background: #fff4f6;
  border-color: #efc3cb;
}
.assistant-comparison-list label:has(input:disabled) {
  opacity: 0.5;
}

.assistant-comparison-list label span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.assistant-settings-note {
  margin: 18px 0;
  font-size: 11px !important;
}

.assistant-settings-actions {
  display: flex;
  gap: 10px;
}
.assistant-settings-actions button {
  flex: 1 1;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid #e4e8ee;
  border-radius: 12px;
  background: white;
  color: #232737;
  cursor: pointer;
}
.assistant-settings-actions button:last-child {
  border-color: #e72f44;
  background: #e72f44;
  color: white;
}
.assistant-settings-actions button:disabled {
  opacity: 0.45;
  cursor: default;
}

@media (max-width: 650px) {
  .assistant-conversation-head {
    gap: 10px;
    padding: 10px 12px;
  }
  .assistant-avatar {
    display: none;
  }
  .assistant-conversation .assistant-heading h1 {
    font-size: 18px;
  }
  .assistant-heading p {
    font-size: 11px;
  }
  .assistant-new {
    width: 44px;
    padding: 0;
    flex-shrink: 0;
  }
  .assistant-new span {
    display: none;
  }
  .assistant-context {
    padding: 10px 16px;
    gap: 10px;
  }
  .assistant-context-edit {
    display: none;
  }
  .assistant-context-text strong {
    font-size: 13px;
  }
  .assistant-messages {
    padding: 20px 14px;
  }
  .assistant-intro {
    padding: 4px 0;
  }
  .assistant-intro-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 14px;
  }
  .assistant-intro-icon svg {
    width: 27px;
    height: 27px;
  }
  .assistant-intro h2 {
    font-size: 24px;
  }
  .assistant-intro > p {
    font-size: 13px;
    padding: 0 8px;
  }
  .assistant-prompts {
    margin-top: 20px;
    gap: 8px;
  }
  .assistant-prompts button {
    min-height: 94px;
    padding: 12px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .assistant-prompts button > span:nth-child(2) {
    flex-basis: 100%;
    order: 3;
  }
  .assistant-prompts button strong {
    font-size: 12px;
  }
  .assistant-prompts button small {
    font-size: 10px;
    margin-top: 4px;
  }
  .assistant-prompt-icon {
    width: 28px;
    height: 28px;
    border-radius: 9px;
  }
  .assistant-prompt-icon svg {
    width: 18px;
    height: 18px;
  }
  .assistant-prompt-arrow {
    margin-left: auto;
  }
  .assistant-message {
    margin-bottom: 20px;
  }
  .assistant-text {
    padding: 14px;
    font-size: 14px;
    line-height: 1.65;
  }
  .assistant-copy {
    min-height: 44px;
  }
  .assistant-composer {
    padding: 10px 12px max(10px, env(safe-area-inset-bottom));
  }
  .assistant-composer-field textarea {
    font-size: 16px;
  }
  .assistant-keyboard-hint {
    display: none;
  }
  .assistant-error {
    padding: 10px 14px;
    font-size: 12px;
  }
  .assistant-latest {
    bottom: 106px;
  }
  .assistant-settings-dialog {
    padding: 20px;
  }
}
@media (max-width: 380px) {
  .assistant-settings-dialog .assistant-period {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 650px) and (max-height: 700px) {
  .assistant-messages {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .assistant-intro-icon {
    display: none;
  }
  .assistant-intro h2 {
    font-size: 21px;
    margin-bottom: 8px;
  }
  .assistant-intro > p {
    font-size: 12px;
  }
  .assistant-prompts {
    margin-top: 14px;
    margin-bottom: 4px;
  }
  .assistant-prompts button {
    flex-wrap: nowrap;
    min-height: 62px;
    padding: 10px;
    gap: 8px;
  }
  .assistant-prompts button > span:nth-child(2) {
    flex-basis: auto;
    order: 0;
  }
  .assistant-prompts button small {
    display: none;
  }
  .assistant-prompt-arrow {
    display: none;
  }
  .assistant-about summary {
    min-height: 36px;
  }
  .assistant-composer-hint {
    display: none;
  }
}
@media (max-height: 550px) {
  .assistant-messages {
    padding: 12px 20px;
  }
  .assistant-conversation-head {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .assistant-context {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .assistant-composer {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .assistant-composer-hint {
    display: none;
  }
}
@media (max-width: 1099px) {
  .lkfr-app[data-keyboard-open=true] .assistant-context {
    display: none;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-conversation-head {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-heading p, .lkfr-app[data-keyboard-open=true] .assistant-composer-hint {
    display: none;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-composer {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-messages {
    padding: 8px 12px;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-error {
    padding: 6px 12px;
    max-height: 56px;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-error ~ .assistant-composer .assistant-composer-field textarea {
    max-height: 44px;
  }
  .lkfr-app[data-keyboard-open=true] .assistant-composer-field textarea {
    max-height: min(96px, var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height, 66px) - 110px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .assistant-thinking-dots i {
    animation: none;
  }
}
.assistant-workspace {
  height: 100%;
  min-height: 0;
  min-width: 0;
  display: grid;
  grid-template-columns: 244px minmax(0, 1fr);
  font-family: inherit;
  color: var(--lkfr-ink, #232737);
}

.assistant-workspace .assistant-conversation {
  grid-area: auto;
  background: #fcfcfd;
}

.assistant-sidebar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  padding: 22px 14px 14px;
  border-right: 1px solid #e9eaf0;
  background: #f7f8fb;
}
.assistant-sidebar button, .assistant-sidebar input {
  font: inherit;
}
.assistant-sidebar button {
  cursor: pointer;
}
.assistant-sidebar button:disabled {
  cursor: default;
  opacity: 0.5;
}

.assistant-sidebar-head {
  padding: 0 8px;
}
.assistant-sidebar-head p {
  margin: 7px 0 20px;
  color: #8490a2;
  font-size: 11px;
}

.assistant-sidebar-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 600;
}
.assistant-sidebar-brand svg {
  width: 22px;
  height: 22px;
  color: #e72f44;
}

.assistant-create {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border: 1px solid #e3e5ed;
  border-radius: 12px;
  background: white;
  color: #232737;
  font-size: 13px !important;
}
.assistant-create span {
  font-size: 21px;
  line-height: 1;
}
.assistant-create:hover {
  border-color: #edb3bd;
}

.assistant-history-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-left: 8px;
  color: #7b879b;
  font-size: 12px;
}
.assistant-history-label button {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #7b879b;
}
.assistant-history-label button svg {
  width: 18px;
  height: 18px;
}

.assistant-history-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
  gap: 12px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.assistant-history-search {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 2px;
}
.assistant-history-search svg {
  position: absolute;
  left: 12px;
  width: 17px;
  height: 17px;
  color: #8c97a8;
}
.assistant-history-search input {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 10px 10px 10px 36px;
  border: 1px solid #e4e7ee;
  border-radius: 11px;
  background: white;
  font-size: 16px;
  color: #232737;
  outline-offset: -2px;
}
.assistant-history-search input::placeholder {
  font-size: 13px;
  color: #929bad;
}

.assistant-history-list {
  display: grid;
  gap: 5px;
}

.assistant-history-item {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  border: 1px solid transparent;
  border-radius: 12px;
}
.assistant-history-item:hover {
  background: #eef0f5;
}
.assistant-history-item.is-active {
  background: #fff0f2;
  border-color: #f5d5dc;
}

.assistant-history-open {
  flex: 1 1;
  min-width: 0;
  padding: 12px 6px 12px 10px;
  border: 0;
  background: transparent;
  border-radius: 12px;
  text-align: left;
  color: #232737;
}
.assistant-history-open strong {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.assistant-history-open span, .assistant-history-open small {
  display: block;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  color: #8490a2;
}
.assistant-history-open small {
  color: #99a1af;
}

.assistant-history-delete {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  min-height: 44px;
  padding: 8px;
  margin-top: 5px;
  border: 0;
  background: transparent;
  border-radius: 10px;
  color: #9bA4b3;
}
.assistant-history-delete svg {
  width: 16px;
  height: 16px;
}
.assistant-history-delete:hover {
  color: #e72f44;
  background: #ffe6eb;
}

.assistant-history-empty {
  padding: 24px 10px;
  text-align: center;
  color: #8490a2;
}
.assistant-history-empty > svg {
  display: block;
  width: 26px;
  height: 26px;
  margin: 0 auto 12px;
  color: #acb5c3;
}
.assistant-history-empty strong {
  font-size: 13px;
  font-weight: 500;
  color: #626d81;
}
.assistant-history-empty p {
  font-size: 12px;
  line-height: 1.6;
  margin: 8px 0 0;
}

.assistant-history-state {
  margin: 0;
  padding: 10px;
  color: #7b879b;
  font-size: 12px;
  line-height: 1.5;
}
.assistant-history-state p {
  margin: 0 0 6px;
}
.assistant-history-state button {
  min-height: 44px;
  padding: 8px 12px;
  border: 1px solid #e2e6ee;
  border-radius: 10px;
  background: white;
  color: #232737;
}

.assistant-history-more {
  min-height: 44px;
  flex-shrink: 0;
  border: 1px solid #e4e7ee;
  border-radius: 10px;
  background: white;
  color: #657085;
  font-size: 12px;
}

.assistant-tools {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-height: 44px;
  padding: 10px 8px;
  margin-top: 14px;
  border: 0;
  border-top: 1px solid #e3e6ee;
  background: transparent;
  color: #7b879b;
  text-align: left;
  font-size: 11px !important;
  cursor: pointer;
}
.assistant-tools svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.assistant-workspace .assistant-history-toggle {
  display: none;
}

.assistant-workspace .assistant-conversation-head {
  padding: 14px 20px;
  border-bottom: 0;
}

.assistant-workspace .assistant-context {
  width: auto;
  margin: 0 20px 10px;
  padding: 10px 12px;
  border: 1px solid #e7e9ef;
  border-radius: 12px;
  background: #f8f9fc;
}

.assistant-workspace .assistant-context-text small {
  margin-top: 3px;
}

.assistant-workspace .assistant-messages {
  padding: 22px;
}

.assistant-workspace .assistant-intro {
  padding: 8px 0 0;
}

.assistant-intro-eyebrow {
  display: block;
  font-size: 10px;
  letter-spacing: 0.12em;
  color: #9a8191;
  margin-bottom: 18px;
}

.assistant-workspace .assistant-intro-icon {
  background: linear-gradient(145deg, #fff0f3, #f5eefb);
  box-shadow: 0 0 44px 15px rgba(248, 238, 245, 0.4588235294);
}

.assistant-workspace .assistant-intro h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
}

.assistant-workspace .assistant-prompts {
  margin-top: 22px;
}

.assistant-workspace .assistant-prompts button {
  min-height: 76px;
  padding: 12px;
  border-radius: 14px;
  box-shadow: 0 2px 3px rgba(35, 39, 55, 0.0078431373);
}

.assistant-workspace .assistant-prompt-icon {
  background: #fff1f3;
  color: #cd5066;
}

.assistant-workspace .assistant-prompts button:nth-child(2) .assistant-prompt-icon {
  background: #f1eefa;
  color: #7f65b1;
}

.assistant-workspace .assistant-prompts button:nth-child(3) .assistant-prompt-icon {
  background: #eaf6f1;
  color: #528875;
}

.assistant-workspace .assistant-prompts button:nth-child(4) .assistant-prompt-icon {
  background: #eff3fb;
  color: #6b84b9;
}

.assistant-intro-trust {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  font-size: 10px;
  color: #99a1af;
}
.assistant-intro-trust span {
  display: flex;
  align-items: center;
  gap: 4px;
}
.assistant-intro-trust svg {
  width: 13px;
  height: 13px;
}

.assistant-workspace .assistant-message.user .assistant-text {
  background: #f0edf7;
  border-color: #e9e3f1;
}

.assistant-workspace .assistant-text {
  line-height: 1.6;
}

.assistant-workspace .assistant-composer {
  border-top: 0;
  padding-top: 10px;
}

.assistant-workspace .assistant-composer-field {
  border-radius: 18px;
  box-shadow: 0 4px 20px rgba(35, 39, 55, 0.0196078431);
}

.lkfr-dialog-overlay:has(> :is(.assistant-history-dialog, .assistant-delete-dialog)) {
  height: var(--assistant-dialog-viewport, 100dvh);
}

.lkfr-dialog.assistant-history-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 480px);
  max-height: calc(var(--assistant-dialog-viewport, 100dvh) - 32px);
  min-height: min(480px, var(--assistant-dialog-viewport, 100dvh) - 32px);
}
.lkfr-dialog.assistant-history-dialog .assistant-history-body {
  margin-top: 16px;
}
.lkfr-dialog.assistant-history-dialog button, .lkfr-dialog.assistant-history-dialog input {
  font: inherit;
}
.lkfr-dialog.assistant-history-dialog .assistant-history-delete {
  width: 44px;
}

.lkfr-dialog.assistant-delete-dialog {
  width: min(100%, 420px);
}
.lkfr-dialog.assistant-delete-dialog p {
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.lkfr-dialog:is(.assistant-history-dialog, .assistant-delete-dialog) {
  font-family: "Cera Pro", Arial, sans-serif;
}
.lkfr-dialog:is(.assistant-history-dialog, .assistant-delete-dialog) .lkfr-dialog-heading {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.lkfr-dialog:is(.assistant-history-dialog, .assistant-delete-dialog) .lkfr-dialog-heading h2 {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
}
.lkfr-dialog:is(.assistant-history-dialog, .assistant-delete-dialog) .lkfr-dialog-heading button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border: 1px solid #e4e8ee;
  border-radius: 12px;
  background: white;
  color: #657085;
  font-size: 23px;
  cursor: pointer;
}

.assistant-workspace :is(button, input):focus-visible, .assistant-history-dialog :is(button, input):focus-visible {
  outline: 3px solid #5365cc;
  outline-offset: -2px;
}

@media (max-width: 1099px) {
  .assistant-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .assistant-sidebar {
    display: none;
  }
  .assistant-workspace .assistant-history-toggle {
    display: inline-flex;
    width: 44px;
  }
  .assistant-workspace .assistant-history-toggle svg {
    width: 21px;
    height: 21px;
  }
}
@media (max-width: 650px) {
  .assistant-workspace .assistant-conversation-head {
    padding: 10px 12px;
  }
  .assistant-workspace .assistant-context {
    margin: 0 12px 4px;
    padding: 9px 10px;
  }
  .assistant-workspace .assistant-messages {
    padding: 18px 14px 12px;
  }
  .assistant-intro-eyebrow {
    font-size: 9px;
    margin-bottom: 15px;
    letter-spacing: 0.08em;
  }
  .assistant-workspace .assistant-intro h2 {
    font-size: 25px;
  }
  .assistant-workspace .assistant-prompts {
    margin-top: 18px;
    margin-bottom: 14px;
  }
  .assistant-workspace .assistant-prompts button {
    flex-wrap: nowrap;
    gap: 9px;
    min-height: 76px;
    padding: 11px;
  }
  .assistant-workspace .assistant-prompts button > span:nth-child(2) {
    flex-basis: auto;
    order: 0;
  }
  .assistant-workspace .assistant-prompts button small {
    font-size: 10px;
  }
  .assistant-workspace .assistant-prompt-arrow {
    display: none;
  }
  .assistant-intro-trust {
    gap: 8px;
    font-size: 9px;
  }
  .assistant-workspace .assistant-composer {
    padding: 8px 12px max(10px, env(safe-area-inset-bottom));
  }
  .assistant-workspace .assistant-text {
    padding: 14px;
  }
  .assistant-history-dialog .assistant-history-search input {
    font-size: 16px;
  }
}
@media (max-width: 650px) and (max-height: 720px) {
  .assistant-workspace .assistant-messages {
    padding-top: 12px;
  }
  .assistant-intro-eyebrow, .assistant-intro-trust {
    display: none;
  }
  .assistant-workspace .assistant-prompts button {
    min-height: 62px;
  }
  .assistant-workspace .assistant-intro h2 {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ChatsPage/AssistantConversation.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAAoB,oBAAA;EAA4B,YAAA;EAAc,aAAA;EAAe,YAAA;EAC7E,aAAA;EAAe,sBAAA;EAAwB,gBAAA;EACvC,+BAAA;EAAiC,mBAAA;EAAqB,oBAAA;EACtD,gBAAA;EAAkB,sBAAA;EAAwB,oBAAA;AAW5C;AAVE;EAAkC,aAAA;AAapC;AAZE;EAAS,eAAA;AAeX;AAdE;EAAkB,aAAA;EAAc,eAAA;AAkBlC;AAjBE;EAA+C,0BAAA;EAA4B,mBAAA;AAqB7E;AApBE;EAAM,cAAA;AAuBR;;AArBA;EAA+B,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,oDAAA;EAAsD,iBAAA;AA+BxK;;AA9BA;EAAiC,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,yBAAA;EAA2B,eAAA;EAAiB,aAAA;EAAe,iBAAA;EAAmB,iBAAA;EAAmB,gCAAA;AA0CtL;AA1CwN;EAAS,gBAAA;EAAkB,cAAA;EAAgB,SAAA;EAAW,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAkDxT;;AAjDA;EAA8B,aAAA;EAAe,eAAA;EAAiB,mBAAA;EAAqB,yBAAA;EAA2B,QAAA;EAAU,iBAAA;AA0DxH;;AAzDA;EAAkB,gBAAA;EAAkB,SAAA;EAAW,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAAqB,cAAA;EAAgB,0BAAA;AAmE1H;;AAlEA;EAA6B,eAAA;AAsE7B;;AArEA;EAAqB,SAAA;EAAS,YAAA;AA0E9B;AA1E4C;EAAK,eAAA;EAAiB,gBAAA;EAAkB,SAAA;EAAW,gBAAA;EAAkB,uBAAA;AAiFjH;AAjF2I;EAAI,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,iCAAA;AAuFnM;;AAtFA;EAAgD,eAAA;EAAiB,gBAAA;EAAkB,SAAA;EAAW,gBAAA;EAAkB,uBAAA;AA8FhH;;AA7FA;EAA2C,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,kCAAA;EAAoC,4CAAA;EAA8C,cAAA;AAsGtL;;AArGA;EAAoB,WAAA;EAAa,YAAA;AA0GjC;AA1G+C;EAAM,WAAA;EAAa,YAAA;AA8GlE;;AA7GA;EAAyC,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,gBAAA;EAAkB,6CAAA;EAA+C,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;AAyHhO;;AAxHA;EAAyB,WAAA;EAAa,cAAA;AA6HtC;;AA5HA;EAAiB,eAAA;EAAiB,0BAAA;AAiIlC;AAjI8D;EAAM,WAAA;EAAa,YAAA;AAqIjF;;AApIA;EAAqB,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,SAAA;EAAW,oDAAA;EAAsD,iBAAA;EAAmB,cAAA;EAAgB,gBAAA;AAmJvO;;AAlJA;EAA0B,iCAAA;AAsJ1B;AAtJ6D;EAAM,cAAA;EAAgB,WAAA;EAAa,YAAA;AA2JhG;;AA1JA;EAA0B,SAAA;EAAS,YAAA;AA+JnC;AA/JiD;EAAS,cAAA;EAAgB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;AAuK3J;AAvK+K;EAAQ,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,iCAAA;AA6KzO;;AA5KA;EAA0B,eAAA;EAAiB,iCAAA;AAiL3C;;AAhLA;EAA2B,WAAA;EAAa,iCAAA;AAqLxC;;AApLA;EAAsB,kBAAA;EAAoB,SAAA;EAAa,aAAA;EAAe,gBAAA;EAAkB,kBAAA;EAAoB,4BAAA;EAA8B,qBAAA;AA8L1I;;AA7LA;EAAmB,uBAAA;EAAyB,YAAA;EAAc,eAAA;EAAiB,kBAAA;AAoM3E;;AAnMA;EAAwB,WAAA;EAAa,YAAA;EAAc,mBAAA;AAyMnD;AAzMwE;EAAM,WAAA;EAAa,YAAA;AA6M3F;;AA5MA;EAAsB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;EAAkB,wBAAA;AAoN7F;;AAnNA;EAAuB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,iCAAA;EAAmC,gBAAA;AA2N7G;;AA1NA;EAAqB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,mBAAA;EAAqB,gBAAA;AAkOtH;;AAjOA;EAA4B,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;EAAc,gBAAA;EAAkB,aAAA;EAAe,6CAAA;EAA+C,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,gBAAA;EAAkB,gDAAA;AAgPnP;AAhPmS;EAAsB,SAAA;EAAS,YAAA;AAoPlU;AApPkV;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AA0P9Y;AA1Pka;EAAQ,cAAA;EAAgB,eAAA;EAAiB,iCAAA;EAAmC,eAAA;EAAiB,iBAAA;AAiQ/f;AAjQohB;EAAyB,6CAAA;EAAyB,mBAAA;AAqQtkB;;AApQA;EAAyB,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;AA+QlJ;AA/QkK;EAAM,WAAA;EAAa,YAAA;AAmRrL;;AAlRA;EAA0B,cAAA;EAAgB,eAAA;AAuR1C;;AAtRA;EAAmB,eAAA;EAAiB,iCAAA;AA2RpC;AA3RuE;EAAU,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;AAiS9I;AAjSiK;EAAI,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,kBAAA;EAAoB,6CAAA;EAA+C,mBAAA;EAAqB,SAAA;EAAW,iBAAA;AA2S9T;;AA1SA;EAA0B,mBAAA;EAAqB,kBAAA;EAAoB,SAAA;EAAW,mBAAA;EAAqB,uCAAA;EAAyC,YAAA;AAmT5I;;AAlTA;EAAqB,uBAAA;EAAyB,mBAAA;EAAqB,uBAAA;AAwTnE;;AAvTA;EAA6B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,kBAAA;AA+T5G;AA/TgI;EAAS,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,iCAAA;EAAmC,eAAA;EAAiB,gBAAA;AAuU3O;AAvU6P;EAAM,WAAA;EAAa,YAAA;EAAc,kCAAA;AA4U9R;;AA3UA;EAA0B,aAAA;EAAe,sBAAA;EAAwB,qBAAA;AAiVjE;AAjVwF;EAAkB,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;EAAuB,iCAAA;AAuVtK;;AAtVA;EAAkB,kBAAA;EAAoB,SAAA;EAAW,6CAAA;EAA+C,iCAAA;EAAmC,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;AAiWzL;;AAhWA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,gBAAA;EAAkB,SAAA;EAAW,kBAAA;EAAoB,uBAAA;EAAyB,iCAAA;EAAmC,0BAAA;AA4WrL;AA5WiN;EAAU,mBAAA;AA+W3N;;AA9WA;EAAqB,eAAA;EAAiB,iCAAA;EAAmC,eAAA;EAAiB,gBAAA;AAqX1F;AArX4G;EAAU,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,gBAAA;EAAkB,iBAAA;EAAmB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AAgYhR;AAhYkS;EAA4B,aAAA;AAmY9T;AAnY+U;EAAM,WAAA;EAAa,YAAA;AAuYlW;AAvYoX;EAAsB,yBAAA;AA0Y1Y;AA1Yua;EAAQ,oBAAA;AA6Y/a;AA7Yuc;EAAI,aAAA;AAgZ3c;AAhZ4d;EAAK,aAAA;EAAe,QAAA;EAAU,UAAA;EAAY,gBAAA;AAsZtgB;AAtZ0hB;EAAI,cAAA;EAAgB,qBAAA;AA0Z9iB;AA1ZqkB;EAAU,0BAAA;AA6Z/kB;;AA5ZA;EAA4B,kBAAA;EAAoB,eAAA;EAAiB,cAAA;AAkajE;;AAjaA;EAAsB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,uBAAA;EAAyB,qBAAA;EAAuB,iCAAA;EAAmC,eAAA;AA2axJ;;AA1aA;EAA2B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,cAAA;AAibzE;AAjbyF;EAAI,UAAA;EAAY,WAAA;EAAa,mBAAA;EAAqB,kBAAA;EAAoB,uDAAA;AAwb/J;AAxbwN;EAAiB,sBAAA;AA2bzO;AA3bkQ;EAAiB,qBAAA;AA8bnR;;AA7bA;EAAgC;IAAgB,YAAA;IAAa,wBAAA;EAmc3D;EAncuF;IAAM,UAAA;IAAY,2BAAA;EAuczG;AACF;AAvcA;EAAoB,kBAAA;EAAoB,aAAA;EAAe,SAAA;EAAW,2BAAA;EAA6B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;EAAmB,6CAAA;EAA+C,mBAAA;EAAqB,qDAAA;EAAkC,iBAAA;EAAmB,cAAA;EAAgB,0BAAA;AAydhV;;AAxdA;EAAmB,cAAA;EAAgB,kBAAA;EAAoB,iBAAA;EAAmB,gBAAA;EAAkB,6BAAA;EAA+B,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAoejL;AApemM;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,YAAA;EAAc,SAAA;EAAW,uBAAA;EAAyB,cAAA;EAAgB,0BAAA;AA6elT;;AA5eA;EAAwB,SAAA;EAAW,iBAAA;EAAmB,iCAAA;EAAmC,eAAA;AAmfzF;;AAlfA;EAAsB,cAAA;EAAgB,uBAAA;EAAyB,iDAAA;EAAmD,iBAAA;AAyflH;;AAxfA;EAA4B,aAAA;EAAe,qBAAA;EAAuB,QAAA;EAAU,uBAAA;EAAyB,YAAA;EAAc,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;AAogBjL;AApgBoM;EAAiB,qBAAA;EAAuB,qDAAA;AAwgB5O;AAxgB+Q;EAAW,SAAA;EAAS,WAAA;EAAa,YAAA;EAAc,YAAA;EAAc,gBAAA;EAAkB,iBAAA;EAAmB,SAAA;EAAW,qBAAA;EAAuB,mBAAA;EAAqB,aAAA;EAAe,uBAAA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AAwhBjf;AAxhBogB;EAAa,YAAA;AA2hBjhB;AA3hBgiB;EAAiB,cAAA;AA8hBjjB;;AA7hBA;EAAkB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,UAAA;EAAY,SAAA;EAAW,mBAAA;EAAqB,uCAAA;EAAyC,YAAA;AA0iBtL;AA1iBoM;EAAM,WAAA;EAAa,YAAA;AA8iBvN;;AA7iBA;EAA2B,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,kBAAA;EAAoB,cAAA;EAAgB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAyjB3K;;AAxjBA;EAAyD,gDAAA;AA4jBzD;;AA3jBA;EAAyC,uBAAA;EAAyB,iEAAA;EAAmE,gBAAA;EAAkB,4BAAA;EAA8B,0CAAA;AAmkBrL;AAnkBiO;EAAuB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;AAykB5T;AAzkBuU;EAAK,SAAA;EAAW,eAAA;AA6kBvV;AA7kB0W;EAAS,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;AAwlBrgB;;AAvlBA;EAAsB,gBAAA;EAAkB,cAAA;AA4lBxC;AA5lBwD;EAAwB,aAAA;AA+lBhF;AA/lBiG;EAAmC,aAAA;EAAe,YAAA;EAAc,QAAA;EAAU,eAAA;EAAiB,cAAA;AAsmB5L;AAtmB8M;EAA6B,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,kBAAA;EAAoB,sBAAA;EAAwB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AAknBvZ;AAlnB0a;EAAW,UAAA;EAAY,gBAAA;EAAkB,SAAA;EAAW,YAAA;AAwnB9d;AAxnB8e;EAAS,UAAA;EAAY,mBAAA;EAAqB,WAAA;EAAa,eAAA;EAAiB,gBAAA;AA+nBtjB;AA/nBwkB;EAAO,YAAA;EAAc,cAAA;EAAgB,eAAA;AAooB7mB;;AAnoBA;EAA4B,aAAA;EAAe,QAAA;EAAU,mBAAA;AAyoBrD;AAzoB0E;EAAS,SAAA;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAopBtO;;AAnpBA;EAAoB,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAypBrF;;AAxpBA;EAA4B,gBAAA;EAAkB,eAAA;AA6pB9C;;AA5pBA;EAA6B,iBAAA;EAAmB,gBAAA;EAAkB,4BAAA;EAA8B,aAAA;EAAe,QAAA;AAoqB/G;AApqByH;EAAQ,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,eAAA;EAAiB,eAAA;AA+qBvR;AA/qB0S;EAAQ,gBAAA;EAAkB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,qBAAA;AAsrB/W;AAtrBwY;EAA2B,mBAAA;EAAqB,qBAAA;AA0rBxb;AA1rBid;EAA4B,YAAA;AA6rB7e;;AA5rBA;EAAwC,YAAA;EAAc,uBAAA;AAisBtD;;AAhsBA;EAA2B,cAAA;EAAgB,0BAAA;AAqsB3C;;AApsBA;EAA8B,aAAA;EAAe,SAAA;AAysB7C;AAzsBwD;EAAS,SAAA;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AAmtBnM;AAntBoN;EAAe,qBAAA;EAAuB,mBAAA;EAAqB,YAAA;AAwtB/Q;AAxtB+R;EAAa,aAAA;EAAc,eAAA;AA4tB1T;;AA3tBA;EACE;IAA+B,SAAA;IAAW,kBAAA;EAguB1C;EA/tBA;IAAoB,aAAA;EAkuBpB;EAjuBA;IAAgD,eAAA;EAouBhD;EAnuBA;IAAuB,eAAA;EAsuBvB;EAruBA;IAAiB,WAAA;IAAa,UAAA;IAAY,cAAA;EA0uB1C;EA1uB0D;IAAO,aAAA;EA6uBjE;EA5uBA;IAAqB,kBAAA;IAAoB,SAAA;EAgvBzC;EA/uBA;IAA0B,aAAA;EAkvB1B;EAjvBA;IAAiC,eAAA;EAovBjC;EAnvBA;IAAsB,kBAAA;EAsvBtB;EArvBA;IAAmB,cAAA;EAwvBnB;EAvvBA;IAAwB,WAAA;IAAa,YAAA;IAAc,mBAAA;EA4vBnD;EA5vBwE;IAAM,WAAA;IAAa,YAAA;EAgwB3F;EA/vBA;IAAsB,eAAA;EAkwBtB;EAjwBA;IAAuB,eAAA;IAAiB,cAAA;EAqwBxC;EApwBA;IAAqB,gBAAA;IAAkB,QAAA;EAwwBvC;EAvwBA;IAA4B,gBAAA;IAAkB,aAAA;IAAe,eAAA;IAAiB,QAAA;EA6wB9E;EA7wBwF;IAAsB,gBAAA;IAAkB,QAAA;EAixBhI;EAjxB4I;IAAS,eAAA;EAoxBrJ;EApxBwK;IAAQ,eAAA;IAAiB,eAAA;EAwxBjM;EAvxBA;IAAyB,WAAA;IAAa,YAAA;IAAc,kBAAA;EA4xBpD;EA5xBwE;IAAM,WAAA;IAAa,YAAA;EAgyB3F;EA/xBA;IAA0B,iBAAA;EAkyB1B;EAjyBA;IAAqB,mBAAA;EAoyBrB;EAnyBA;IAAkB,aAAA;IAAe,eAAA;IAAiB,iBAAA;EAwyBlD;EAvyBA;IAAkB,gBAAA;EA0yBlB;EAzyBA;IAAsB,yDAAA;EA4yBtB;EA3yBA;IAAqC,eAAA;EA8yBrC;EA7yBA;IAA2B,aAAA;EAgzB3B;EA/yBA;IAAmB,kBAAA;IAAoB,eAAA;EAmzBvC;EAlzBA;IAAoB,aAAA;EAqzBpB;EApzBA;IAA6B,aAAA;EAuzB7B;AACF;AAtzBA;EACE;IAA+C,qCAAA;EAyzB/C;AACF;AAxzBA;EACE;IAAsB,iBAAA;IAAmB,oBAAA;EA4zBzC;EA3zBA;IAAwB,aAAA;EA8zBxB;EA7zBA;IAAsB,eAAA;IAAiB,kBAAA;EAi0BvC;EAh0BA;IAAuB,eAAA;EAm0BvB;EAl0BA;IAAqB,gBAAA;IAAkB,kBAAA;EAs0BvC;EAr0BA;IAA4B,iBAAA;IAAmB,gBAAA;IAAkB,aAAA;IAAe,QAAA;EA20BhF;EA30B0F;IAAsB,gBAAA;IAAkB,QAAA;EA+0BlI;EA/0B8I;IAAQ,aAAA;EAk1BtJ;EAj1BA;IAA0B,aAAA;EAo1B1B;EAn1BA;IAA2B,gBAAA;EAs1B3B;EAr1BA;IAA2B,aAAA;EAw1B3B;AACF;AAv1BA;EACE;IAAsB,kBAAA;EA01BtB;EAz1BA;IAA+B,gBAAA;IAAkB,mBAAA;EA61BjD;EA51BA;IAAqB,gBAAA;IAAkB,mBAAA;EAg2BvC;EA/1BA;IAAsB,gBAAA;IAAkB,mBAAA;EAm2BxC;EAl2BA;IAA2B,aAAA;EAq2B3B;AACF;AAp2BA;EACE;IAA0D,aAAA;EAu2B1D;EAt2BA;IAAoE,gBAAA;IAAkB,mBAAA;EA02BtF;EAz2BA;IAA2H,aAAA;EA42B3H;EA32BA;IAA2D,gBAAA;IAAkB,mBAAA;EA+2B7E;EA92BA;IAA2D,iBAAA;EAi3B3D;EAh3BA;IAAwD,iBAAA;IAAmB,gBAAA;EAo3B3E;EAn3BA;IAAiH,gBAAA;EAs3BjH;EAr3BA;IAA0E,oGAAA;EAw3B1E;AACF;AAv3BA;EAA0C;IAA6B,eAAA;EA23BrE;AACF;AA13BA;EAAuB,YAAA;EAAc,aAAA;EAAe,YAAA;EAAc,aAAA;EAAe,2CAAA;EAA6C,oBAAA;EAAsB,+BAAA;AAm4BpJ;;AAl4BA;EAA+C,eAAA;EAAiB,mBAAA;AAu4BhE;;AAt4BA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,aAAA;EAAe,YAAA;EAAc,uBAAA;EAAyB,+BAAA;EAAiC,mBAAA;AAg5BnJ;AAh5BwK;EAAgB,aAAA;AAm5BxL;AAn5ByM;EAAS,eAAA;AAs5BlN;AAt5BqO;EAAkB,eAAA;EAAiB,YAAA;AA05BxQ;;AAz5BA;EAA0B,cAAA;AA65B1B;AA75B0C;EAAI,kBAAA;EAAoB,cAAA;EAAgB,eAAA;AAk6BlF;;AAj6BA;EAA2B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,gBAAA;AAy6B1F;AAz6B4G;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;AA86B7I;;AA76BA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,WAAA;EAAa,gBAAA;EAAkB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,0BAAA;AA47BhO;AA57B4P;EAAO,eAAA;EAAiB,cAAA;AAg8BpR;AAh8BsS;EAAU,qBAAA;AAm8BhT;;AAl8BA;EAA2B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AA48BpJ;AA58BqK;EAAS,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,SAAA;EAAW,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;AAs9BtS;AAt9BsT;EAAM,WAAA;EAAa,YAAA;AA09BzU;;AAz9BA;EAA0B,aAAA;EAAe,sBAAA;EAAwB,aAAA;EAAe,SAAA;EAAS,SAAA;EAAW,gBAAA;EAAkB,4BAAA;EAA8B,qBAAA;AAo+BpJ;;AAn+BA;EAA4B,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,aAAA;AA0+BpF;AA1+BmG;EAAM,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,YAAA;EAAc,cAAA;AAi/BpK;AAj/BsL;EAAQ,sBAAA;EAAwB,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,4BAAA;EAA8B,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,cAAA;EAAgB,oBAAA;AA8/BrY;AA9/B6Z;EAAqB,eAAA;EAAiB,cAAA;AAkgCnc;;AAjgCA;EAA0B,aAAA;EAAe,QAAA;AAsgCzC;;AArgCA;EAA0B,aAAA;EAAe,YAAA;EAAc,uBAAA;EAAyB,6BAAA;EAA+B,mBAAA;AA6gC/G;AA7gCoI;EAAU,mBAAA;AAghC9I;AAhhCqK;EAAc,mBAAA;EAAqB,qBAAA;AAohCxM;;AAnhCA;EAA0B,SAAA;EAAS,YAAA;EAAc,2BAAA;EAA6B,SAAA;EAAW,uBAAA;EAAyB,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;AA8hCzJ;AA9hCyK;EAAS,oBAAA;EAAsB,qBAAA;EAAuB,4BAAA;EAA8B,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;AAwiCrU;AAxiCgW;EAAc,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAijChe;AAjjCkf;EAAQ,cAAA;AAojC1f;;AAnjCA;EAA4B,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,YAAA;EAAc,eAAA;EAAiB,SAAA;EAAW,uBAAA;EAAyB,mBAAA;EAAqB,cAAA;AAikCvM;AAjkCuN;EAAM,WAAA;EAAa,YAAA;AAqkC1O;AArkC0P;EAAU,cAAA;EAAgB,mBAAA;AAykCpR;;AAxkCA;EAA2B,kBAAA;EAAoB,kBAAA;EAAoB,cAAA;AA8kCnE;AA9kCmF;EAAQ,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,cAAA;AAqlC3J;AArlC6K;EAAS,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AA0lCzN;AA1lC2O;EAAI,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA+lClR;;AA9lCA;EAA2B,SAAA;EAAW,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAsmCtF;AAtmCwG;EAAI,eAAA;AAymC5G;AAzmC+H;EAAS,gBAAA;EAAkB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;AAinChP;;AAhnCA;EAA0B,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AA0nC/I;;AAznCA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,2BAAA;EAA6B,QAAA;EAAU,gBAAA;EAAkB,iBAAA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,6BAAA;EAA+B,uBAAA;EAAyB,cAAA;EAAgB,gBAAA;EAAkB,0BAAA;EAA4B,eAAA;AA0oCtR;AA1oCuS;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;AA+oCxU;;AA9oCA;EAAiD,aAAA;AAkpCjD;;AAjpCA;EAAoD,kBAAA;EAAoB,gBAAA;AAspCxE;;AArpCA;EAA0C,WAAA;EAAa,mBAAA;EAAqB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;AA8pChJ;;AA7pCA;EAAqD,eAAA;AAiqCrD;;AAhqCA;EAA2C,aAAA;AAoqC3C;;AAnqCA;EAAwC,gBAAA;AAuqCxC;;AAtqCA;EAA2B,cAAA;EAAgB,eAAA;EAAiB,sBAAA;EAAuB,cAAA;EAAgB,mBAAA;AA8qCnG;;AA7qCA;EAA6C,qDAAA;EAAuD,2DAAA;AAkrCpG;;AAjrCA;EAA2C,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AAurC9E;;AAtrCA;EAA0C,gBAAA;AA0rC1C;;AAzrCA;EAAiD,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,oDAAA;AAgsCvG;;AA/rCA;EAA8C,mBAAA;EAAqB,cAAA;AAosCnE;;AAnsCA;EAAqF,mBAAA;EAAqB,cAAA;AAwsC1G;;AAvsCA;EAAqF,mBAAA;EAAqB,cAAA;AA4sC1G;;AA3sCA;EAAqF,mBAAA;EAAqB,cAAA;AAgtC1G;;AA/sCA;EAAyB,aAAA;EAAe,uBAAA;EAAyB,eAAA;EAAiB,aAAA;EAAe,eAAA;EAAiB,cAAA;AAwtClH;AAxtCkI;EAAO,aAAA;EAAe,mBAAA;EAAqB,QAAA;AA6tC7K;AA7tCyL;EAAM,WAAA;EAAa,YAAA;AAiuC5M;;AAhuCA;EAA+D,mBAAA;EAAqB,qBAAA;AAquCpF;;AApuCA;EAAuC,gBAAA;AAwuCvC;;AAvuCA;EAA2C,aAAA;EAAe,iBAAA;AA4uC1D;;AA3uCA;EAAiD,mBAAA;EAAqB,qDAAA;AAgvCtE;;AA/uCA;EAAuF,gDAAA;AAmvCvF;;AAlvCA;EAAwC,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,iEAAA;EAAmE,uEAAA;AA0vC3K;AA1vC0P;EAA0B,gBAAA;AA6vCpR;AA7vCwS;EAAgB,aAAA;AAgwCxT;AAhwCyU;EAA4B,WAAA;AAmwCrW;;AAlwCA;EAAuC,uBAAA;AAswCvC;AAtwCgE;EAAI,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AA2wCvG;;AA1wCA;EAAuE,0CAAA;AA8wCvE;AA9wCmH;EAAuB,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;AAqxC9N;AArxCyO;EAAK,SAAA;EAAW,eAAA;EAAiB,gBAAA;AA0xC1Q;AA1xC8R;EAAS,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAuyC1d;;AAtyCkD;EAAmC,0BAAA;EAA4B,oBAAA;AA2yCjH;;AA1yCA;EACE;IAAuB,qCAAA;EA8yCvB;EA7yCA;IAAqB,aAAA;EAgzCrB;EA/yCA;IAAiD,oBAAA;IAAsB,WAAA;EAmzCvE;EAnzCoF;IAAM,WAAA;IAAa,YAAA;EAuzCvG;AACF;AAtzCA;EACE;IAAoD,kBAAA;EAyzCpD;EAxzCA;IAA0C,kBAAA;IAAoB,iBAAA;EA4zC9D;EA3zCA;IAA2C,uBAAA;EA8zC3C;EA7zCA;IAA2B,cAAA;IAAgB,mBAAA;IAAqB,sBAAA;EAk0ChE;EAj0CA;IAA2C,eAAA;EAo0C3C;EAn0CA;IAA0C,gBAAA;IAAkB,mBAAA;EAu0C5D;EAt0CA;IAAiD,iBAAA;IAAmB,QAAA;IAAU,gBAAA;IAAkB,aAAA;EA40ChG;EA50C+G;IAAsB,gBAAA;IAAkB,QAAA;EAg1CvJ;EAh1CmK;IAAQ,eAAA;EAm1C3K;EAl1CA;IAA+C,aAAA;EAq1C/C;EAp1CA;IAAyB,QAAA;IAAU,cAAA;EAw1CnC;EAv1CA;IAA2C,wDAAA;EA01C3C;EAz1CA;IAAuC,aAAA;EA41CvC;EA31CA;IAA4D,eAAA;EA81C5D;AACF;AA71CA;EACE;IAA2C,iBAAA;EAg2C3C;EA/1CA;IAAmD,aAAA;EAk2CnD;EAj2CA;IAAiD,gBAAA;EAo2CjD;EAn2CA;IAA2C,eAAA;EAs2C3C;AACF","sourcesContent":[".assistant-conversation {\n  position: relative; grid-area: 1 / 1 / -1 / -1; height: 100%; min-height: 0; min-width: 0;\n  display: flex; flex-direction: column; overflow: hidden;\n  color: var(--lkfr-ink, #232737); background: #f7f8fa; font-family: inherit;\n  text-align: left; letter-spacing: normal; word-spacing: normal;\n  button, input, select, textarea { font: inherit; }\n  button { cursor: pointer; }\n  button:disabled { opacity: .45; cursor: default; }\n  :is(button, summary, textarea):focus-visible { outline: 3px solid #5365cc; outline-offset: 3px; }\n  svg { flex-shrink: 0; }\n}\n.assistant-conversation-head { display: flex; flex: 0 0 auto; align-items: center; gap: 12px; padding: 16px 20px; border-bottom: 1px solid var(--lkfr-border, #e4e8ee); background: white; }\n.assistant-feedback-navigation { display: flex; flex: 0 0 auto; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 4px 16px; padding: 2px 16px; background: white; border-bottom: 1px solid #e4e8ee; button { min-height: 40px; padding: 4px 0; border: 0; background: transparent; font-size: 12px; color: #a82540; } }\n.assistant-response-actions { display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 8px; margin-left: auto; }\n.assistant-rate { min-height: 36px; border: 0; border-radius: 8px; padding: 6px 8px; background: #fff0f3; color: #a82540; font-size: 12px !important; }\n.assistant-message-heading { flex-wrap: wrap; }\n.assistant-heading { flex: 1; min-width: 0; h1 { font-size: 20px; line-height: 1.2; margin: 0; font-weight: 600; letter-spacing: -.02em; } p { margin: 4px 0 0; font-size: 12px; line-height: 1.3; color: var(--lkfr-muted, #657085); } }\n.assistant-conversation .assistant-heading h1 { font-size: 20px; line-height: 1.2; margin: 0; font-weight: 600; letter-spacing: -.02em; }\n.assistant-avatar, .assistant-intro-icon { display: grid; place-items: center; border-radius: 14px; color: var(--lkfr-accent, #e72f44); background: var(--lkfr-accent-soft, #fff0f2); flex-shrink: 0; }\n.assistant-avatar { width: 40px; height: 40px; svg { width: 24px; height: 24px; } }\n.assistant-icon-button, .assistant-new { display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 44px; border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 12px; background: white; color: inherit; }\n.assistant-icon-button { width: 40px; flex-shrink: 0; }\n.assistant-new { padding: 0 12px; font-size: 12px !important; svg { width: 18px; height: 18px; } }\n.assistant-context { flex: 0 0 auto; display: flex; align-items: center; gap: 12px; width: 100%; min-width: 0; padding: 12px 24px; border: 0; border-bottom: 1px solid var(--lkfr-border, #e4e8ee); background: white; color: inherit; text-align: left; }\n.assistant-context-icon { color: var(--lkfr-muted, #657085); svg { display: block; width: 20px; height: 20px; } }\n.assistant-context-text { flex: 1; min-width: 0; strong { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 13px; font-weight: 500; } small { display: block; margin-top: 4px; font-size: 11px; color: var(--lkfr-muted, #657085); } }\n.assistant-context-edit { font-size: 12px; color: var(--lkfr-muted, #657085); }\n.assistant-context > svg { width: 16px; color: var(--lkfr-muted, #657085); }\n.assistant-messages { position: relative; flex: 1 1 0; min-height: 0; overflow-y: auto; padding: 28px 24px; overscroll-behavior: contain; scrollbar-width: thin; }\n.assistant-intro { width: min(100%, 600px); margin: auto; padding: 14px 0; text-align: center; }\n.assistant-intro-icon { width: 52px; height: 52px; margin: 0 auto 18px; svg { width: 31px; height: 31px; } }\n.assistant-intro h2 { font-size: 27px; line-height: 1.2; font-weight: 600; margin: 0 0 12px; letter-spacing: -.035em; }\n.assistant-intro > p { max-width: 440px; margin: 0 auto; font-size: 14px; color: var(--lkfr-muted, #657085); line-height: 1.6; }\n.assistant-prompts { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin: 24px 0 16px; text-align: left; }\n.assistant-prompts button { display: flex; align-items: center; gap: 10px; min-width: 0; min-height: 84px; padding: 14px; border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 14px; background: white; color: inherit; text-align: left; transition: border-color .15s, background .15s; > span:nth-child(2) { flex: 1; min-width: 0; } strong { display: block; font-size: 13px; font-weight: 500; line-height: 1.3; } small { display: block; margin-top: 5px; color: var(--lkfr-muted, #657085); font-size: 11px; line-height: 1.35; } &:hover:not(:disabled) { border-color: #e72f4460; background: #fffafb; } }\n.assistant-prompt-icon { display: grid; place-items: center; flex-shrink: 0; width: 32px; height: 32px; border-radius: 10px; background: #f3f5f8; color: #627086; svg { width: 20px; height: 20px; } }\n.assistant-prompt-arrow { color: #8590a2; font-size: 15px; }\n.assistant-about { font-size: 11px; color: var(--lkfr-muted, #657085); summary { display: inline-flex; align-items: center; min-height: 44px; cursor: pointer; } p { font-size: 12px; line-height: 1.55; text-align: left; padding: 12px 14px; border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 12px; margin: 0; background: white; } }\n.assistant-select-salon { margin: 20px 0 10px; padding: 12px 18px; border: 0; border-radius: 12px; background: var(--lkfr-accent, #e72f44); color: white; }\n.assistant-message { width: min(100%, 720px); margin: 0 auto 24px; overflow-wrap: anywhere; }\n.assistant-message-heading { display: flex; justify-content: space-between; align-items: center; gap: 10px; margin-bottom: 8px; strong { display: flex; align-items: center; gap: 7px; color: var(--lkfr-muted, #657085); font-size: 12px; font-weight: 500; svg { width: 17px; height: 17px; color: var(--lkfr-accent, #e72f44); } } }\n.assistant-message.user { display: flex; flex-direction: column; align-items: flex-end; .assistant-text { max-width: 88%; background: #ffedef; border-color: #ffe0e5; border-radius: 16px 16px 4px 16px; } }\n.assistant-text { padding: 18px 20px; margin: 0; border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 4px 16px 16px 16px; background: white; font-size: 15px; line-height: 1.7; white-space: pre-wrap; }\n.assistant-copy { display: flex; align-items: center; min-height: 32px; padding: 4px 8px; border: 0; border-radius: 8px; background: transparent; color: var(--lkfr-muted, #657085); font-size: 11px !important; &:hover { background: #eef1f5; } }\n.assistant-sources { margin-top: 8px; color: var(--lkfr-muted, #657085); font-size: 12px; line-height: 1.5; summary { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 44px; padding: 8px 12px; border-radius: 10px; cursor: pointer; list-style: none; &::-webkit-details-marker { display: none; } svg { width: 14px; height: 14px; } } &[open] summary svg { transform: rotate(180deg); } > div { padding: 0 12px 12px; } p { margin: 8px 0; } ul { display: grid; gap: 8px; padding: 0; list-style: none; } a { color: #bd213a; text-decoration: none; &:hover { text-decoration: underline; } } }\n.assistant-source-warning { margin: 8px 12px 0; font-size: 12px; color: #9a651c; }\n.assistant-thinking { display: flex; align-items: center; gap: 12px; width: min(100%, 720px); margin: 8px auto 16px; color: var(--lkfr-muted, #657085); font-size: 12px; }\n.assistant-thinking-dots { display: flex; align-items: center; gap: 4px; flex-shrink: 0; i { width: 5px; height: 5px; background: #e72f44; border-radius: 50%; animation: assistant-thinking 1.3s ease-in-out infinite; &:nth-child(2) { animation-delay: .15s; } &:nth-child(3) { animation-delay: .3s; } } }\n@keyframes assistant-thinking { 0%, 70%, 100% { opacity: .3; transform: translateY(0); } 35% { opacity: 1; transform: translateY(-3px); } }\n.assistant-latest { position: absolute; bottom: 112px; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 6px; white-space: nowrap; min-height: 44px; padding: 8px 14px; border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 22px; box-shadow: 0 3px 15px #23273712; background: white; color: inherit; font-size: 12px !important; }\n.assistant-error { flex: 0 0 auto; padding: 10px 20px; max-height: 100px; overflow-y: auto; border-top: 1px solid #ffdde3; background: #fff3f5; color: #af2135; font-size: 13px; line-height: 1.4; button { min-height: 44px; margin-left: 8px; padding: 8px; border: 0; background: transparent; color: inherit; text-decoration: underline; } }\n.assistant-copy-error { margin: 0; padding: 5px 20px; color: var(--lkfr-muted, #657085); font-size: 11px; }\n.assistant-composer { flex: 0 0 auto; padding: 14px 24px 12px; border-top: 1px solid var(--lkfr-border, #e4e8ee); background: white; }\n.assistant-composer-field { display: flex; align-items: flex-end; gap: 8px; width: min(100%, 760px); margin: auto; padding: 6px; border: 1px solid #d8dee8; border-radius: 16px; background: white; &:focus-within { border-color: #dd7180; box-shadow: 0 0 0 3px #e72f4409; } textarea { flex: 1; width: 100%; min-width: 0; resize: none; min-height: 44px; max-height: 144px; border: 0; outline: 0 !important; border-radius: 10px; padding: 10px; background: transparent; color: inherit; font-size: 15px; line-height: 24px; &:disabled { opacity: .6; } &::placeholder { color: #8c95a5; } } }\n.assistant-send { width: 44px; height: 44px; flex-shrink: 0; display: grid; place-items: center; padding: 0; border: 0; border-radius: 12px; background: var(--lkfr-accent, #e72f44); color: white; svg { width: 22px; height: 22px; } }\n.assistant-composer-hint { display: flex; justify-content: space-between; gap: 8px; max-width: 760px; margin: 8px auto 0; padding: 0 5px; color: #8490a2; font-size: 10px; line-height: 1.4; }\n.lkfr-dialog-overlay:has(> .assistant-settings-dialog) { height: var(--assistant-dialog-viewport, 100dvh); }\n.lkfr-dialog.assistant-settings-dialog { width: min(100%, 480px); max-height: calc(var(--assistant-dialog-viewport, 100dvh) - 32px); overflow-y: auto; overscroll-behavior: contain; font-family: \"Cera Pro\", Arial, sans-serif; .lkfr-dialog-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; h2 { margin: 0; font-size: 23px; } button { flex-shrink: 0; display: grid; place-items: center; width: 44px; height: 44px; border: 1px solid #e4e8ee; border-radius: 12px; background: white; font-size: 23px; } } }\n.assistant-settings { margin-top: 20px; color: #232737; button, input, select { font: inherit; } > label, .assistant-period label { display: grid; min-width: 0; gap: 7px; font-size: 12px; color: #657085; } select, input[type=\"date\"] { width: 100%; min-width: 0; min-height: 44px; padding: 10px 12px; box-sizing: border-box; border: 1px solid #dce2eb; border-radius: 10px; background: white; color: #232737; font-size: 16px; } fieldset { padding: 0; margin: 22px 0 0; border: 0; min-width: 0; } legend { padding: 0; margin-bottom: 10px; width: 100%; font-size: 13px; font-weight: 500; span { float: right; color: #8490a2; font-size: 11px; } } }\n.assistant-period-presets { display: flex; gap: 7px; margin-bottom: 12px; button { flex: 1; min-height: 44px; padding: 8px 5px; border: 1px solid #e4e8ee; border-radius: 10px; background: #f5f7fa; color: #46536a; font-size: 12px; cursor: pointer; } }\n.assistant-period { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n.assistant-comparison > p { margin: 0 0 10px; font-size: 12px; }\n.assistant-comparison-list { max-height: 180px; overflow-y: auto; overscroll-behavior: contain; display: grid; gap: 6px; label { display: flex; align-items: center; gap: 10px; min-height: 48px; padding: 10px 12px; border: 1px solid #e4e8ee; border-radius: 10px; font-size: 13px; cursor: pointer; } input { appearance: auto; flex-shrink: 0; width: 18px; height: 18px; accent-color: #e72f44; } label:has(input:checked) { background: #fff4f6; border-color: #efc3cb; } label:has(input:disabled) { opacity: .5; } }\n.assistant-comparison-list label span { min-width: 0; overflow-wrap: anywhere; }\n.assistant-settings-note { margin: 18px 0; font-size: 11px !important; }\n.assistant-settings-actions { display: flex; gap: 10px; button { flex: 1; min-height: 44px; padding: 10px 12px; border: 1px solid #e4e8ee; border-radius: 12px; background: white; color: #232737; cursor: pointer; &:last-child { border-color: #e72f44; background: #e72f44; color: white; } &:disabled { opacity: .45; cursor: default; } } }\n@media (max-width: 650px) {\n  .assistant-conversation-head { gap: 10px; padding: 10px 12px; }\n  .assistant-avatar { display: none; }\n  .assistant-conversation .assistant-heading h1 { font-size: 18px; }\n  .assistant-heading p { font-size: 11px; }\n  .assistant-new { width: 44px; padding: 0; flex-shrink: 0; span { display: none; } }\n  .assistant-context { padding: 10px 16px; gap: 10px; }\n  .assistant-context-edit { display: none; }\n  .assistant-context-text strong { font-size: 13px; }\n  .assistant-messages { padding: 20px 14px; }\n  .assistant-intro { padding: 4px 0; }\n  .assistant-intro-icon { width: 44px; height: 44px; margin-bottom: 14px; svg { width: 27px; height: 27px; } }\n  .assistant-intro h2 { font-size: 24px; }\n  .assistant-intro > p { font-size: 13px; padding: 0 8px; }\n  .assistant-prompts { margin-top: 20px; gap: 8px; }\n  .assistant-prompts button { min-height: 94px; padding: 12px; flex-wrap: wrap; gap: 8px; > span:nth-child(2) { flex-basis: 100%; order: 3; } strong { font-size: 12px; } small { font-size: 10px; margin-top: 4px; } }\n  .assistant-prompt-icon { width: 28px; height: 28px; border-radius: 9px; svg { width: 18px; height: 18px; } }\n  .assistant-prompt-arrow { margin-left: auto; }\n  .assistant-message { margin-bottom: 20px; }\n  .assistant-text { padding: 14px; font-size: 14px; line-height: 1.65; }\n  .assistant-copy { min-height: 44px; }\n  .assistant-composer { padding: 10px 12px max(10px, env(safe-area-inset-bottom)); }\n  .assistant-composer-field textarea { font-size: 16px; }\n  .assistant-keyboard-hint { display: none; }\n  .assistant-error { padding: 10px 14px; font-size: 12px; }\n  .assistant-latest { bottom: 106px; }\n  .assistant-settings-dialog { padding: 20px; }\n}\n@media (max-width: 380px) {\n  .assistant-settings-dialog .assistant-period { grid-template-columns: minmax(0, 1fr); }\n}\n@media (max-width: 650px) and (max-height: 700px) {\n  .assistant-messages { padding-top: 14px; padding-bottom: 14px; }\n  .assistant-intro-icon { display: none; }\n  .assistant-intro h2 { font-size: 21px; margin-bottom: 8px; }\n  .assistant-intro > p { font-size: 12px; }\n  .assistant-prompts { margin-top: 14px; margin-bottom: 4px; }\n  .assistant-prompts button { flex-wrap: nowrap; min-height: 62px; padding: 10px; gap: 8px; > span:nth-child(2) { flex-basis: auto; order: 0; } small { display: none; } }\n  .assistant-prompt-arrow { display: none; }\n  .assistant-about summary { min-height: 36px; }\n  .assistant-composer-hint { display: none; }\n}\n@media (max-height: 550px) {\n  .assistant-messages { padding: 12px 20px; }\n  .assistant-conversation-head { padding-top: 6px; padding-bottom: 6px; }\n  .assistant-context { padding-top: 6px; padding-bottom: 6px; }\n  .assistant-composer { padding-top: 6px; padding-bottom: 6px; }\n  .assistant-composer-hint { display: none; }\n}\n@media (max-width: 1099px) {\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-context { display: none; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-conversation-head { padding-top: 6px; padding-bottom: 6px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-heading p, .lkfr-app[data-keyboard-open=\"true\"] .assistant-composer-hint { display: none; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-composer { padding-top: 6px; padding-bottom: 6px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-messages { padding: 8px 12px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-error { padding: 6px 12px; max-height: 56px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-error ~ .assistant-composer .assistant-composer-field textarea { max-height: 44px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .assistant-composer-field textarea { max-height: min(96px, calc(var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height, 66px) - 110px)); }\n}\n@media (prefers-reduced-motion: reduce) { .assistant-thinking-dots i { animation: none; } }\n\n.assistant-workspace { height: 100%; min-height: 0; min-width: 0; display: grid; grid-template-columns: 244px minmax(0, 1fr); font-family: inherit; color: var(--lkfr-ink, #232737); }\n.assistant-workspace .assistant-conversation { grid-area: auto; background: #fcfcfd; }\n.assistant-sidebar { display: flex; flex-direction: column; min-height: 0; min-width: 0; padding: 22px 14px 14px; border-right: 1px solid #e9eaf0; background: #f7f8fb; button, input { font: inherit; } button { cursor: pointer; } button:disabled { cursor: default; opacity: .5; } }\n.assistant-sidebar-head { padding: 0 8px; p { margin: 7px 0 20px; color: #8490a2; font-size: 11px; } }\n.assistant-sidebar-brand { display: flex; align-items: center; gap: 8px; font-size: 17px; font-weight: 600; svg { width: 22px; height: 22px; color: #e72f44; } }\n.assistant-create { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; min-height: 44px; padding: 8px 12px; border: 1px solid #e3e5ed; border-radius: 12px; background: white; color: #232737; font-size: 13px !important; span { font-size: 21px; line-height: 1; } &:hover { border-color: #edb3bd; } }\n.assistant-history-label { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; padding-left: 8px; color: #7b879b; font-size: 12px; button { display: grid; place-items: center; width: 44px; height: 44px; border: 0; border-radius: 10px; background: transparent; color: #7b879b; svg { width: 18px; height: 18px; } } }\n.assistant-history-body { display: flex; flex-direction: column; min-height: 0; flex: 1; gap: 12px; overflow-y: auto; overscroll-behavior: contain; scrollbar-width: thin; }\n.assistant-history-search { position: relative; display: flex; align-items: center; margin: 0 2px; svg { position: absolute; left: 12px; width: 17px; height: 17px; color: #8c97a8; } input { box-sizing: border-box; width: 100%; min-width: 0; min-height: 44px; padding: 10px 10px 10px 36px; border: 1px solid #e4e7ee; border-radius: 11px; background: white; font-size: 16px; color: #232737; outline-offset: -2px; } input::placeholder { font-size: 13px; color: #929bad; } }\n.assistant-history-list { display: grid; gap: 5px; }\n.assistant-history-item { display: flex; min-width: 0; align-items: flex-start; border: 1px solid transparent; border-radius: 12px; &:hover { background: #eef0f5; } &.is-active { background: #fff0f2; border-color: #f5d5dc; } }\n.assistant-history-open { flex: 1; min-width: 0; padding: 12px 6px 12px 10px; border: 0; background: transparent; border-radius: 12px; text-align: left; color: #232737; strong { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; font-weight: 500; font-size: 13px; line-height: 1.45; overflow-wrap: anywhere; } span, small { display: block; margin-top: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 11px; color: #8490a2; } small { color: #99a1af; } }\n.assistant-history-delete { display: grid; place-items: center; flex-shrink: 0; width: 36px; min-height: 44px; padding: 8px; margin-top: 5px; border: 0; background: transparent; border-radius: 10px; color: #9bA4b3; svg { width: 16px; height: 16px; } &:hover { color: #e72f44; background: #ffe6eb; } }\n.assistant-history-empty { padding: 24px 10px; text-align: center; color: #8490a2; > svg { display: block; width: 26px; height: 26px; margin: 0 auto 12px; color: #acb5c3; } strong { font-size: 13px; font-weight: 500; color: #626d81; } p { font-size: 12px; line-height: 1.6; margin: 8px 0 0; } }\n.assistant-history-state { margin: 0; padding: 10px; color: #7b879b; font-size: 12px; line-height: 1.5; p { margin: 0 0 6px; } button { min-height: 44px; padding: 8px 12px; border: 1px solid #e2e6ee; border-radius: 10px; background: white; color: #232737; } }\n.assistant-history-more { min-height: 44px; flex-shrink: 0; border: 1px solid #e4e7ee; border-radius: 10px; background: white; color: #657085; font-size: 12px; }\n.assistant-tools { display: flex; align-items: center; justify-content: flex-start; gap: 8px; min-height: 44px; padding: 10px 8px; margin-top: 14px; border: 0; border-top: 1px solid #e3e6ee; background: transparent; color: #7b879b; text-align: left; font-size: 11px !important; cursor: pointer; svg { width: 18px; height: 18px; flex-shrink: 0; } }\n.assistant-workspace .assistant-history-toggle { display: none; }\n.assistant-workspace .assistant-conversation-head { padding: 14px 20px; border-bottom: 0; }\n.assistant-workspace .assistant-context { width: auto; margin: 0 20px 10px; padding: 10px 12px; border: 1px solid #e7e9ef; border-radius: 12px; background: #f8f9fc; }\n.assistant-workspace .assistant-context-text small { margin-top: 3px; }\n.assistant-workspace .assistant-messages { padding: 22px; }\n.assistant-workspace .assistant-intro { padding: 8px 0 0; }\n.assistant-intro-eyebrow { display: block; font-size: 10px; letter-spacing: .12em; color: #9a8191; margin-bottom: 18px; }\n.assistant-workspace .assistant-intro-icon { background: linear-gradient(145deg, #fff0f3, #f5eefb); box-shadow: 0 0 44px 15px #f8eef575; }\n.assistant-workspace .assistant-intro h2 { font-size: 30px; line-height: 1.2; font-weight: 600; }\n.assistant-workspace .assistant-prompts { margin-top: 22px; }\n.assistant-workspace .assistant-prompts button { min-height: 76px; padding: 12px; border-radius: 14px; box-shadow: 0 2px 3px #23273702; }\n.assistant-workspace .assistant-prompt-icon { background: #fff1f3; color: #cd5066; }\n.assistant-workspace .assistant-prompts button:nth-child(2) .assistant-prompt-icon { background: #f1eefa; color: #7f65b1; }\n.assistant-workspace .assistant-prompts button:nth-child(3) .assistant-prompt-icon { background: #eaf6f1; color: #528875; }\n.assistant-workspace .assistant-prompts button:nth-child(4) .assistant-prompt-icon { background: #eff3fb; color: #6b84b9; }\n.assistant-intro-trust { display: flex; justify-content: center; flex-wrap: wrap; gap: 8px 14px; font-size: 10px; color: #99a1af; span { display: flex; align-items: center; gap: 4px; } svg { width: 13px; height: 13px; } }\n.assistant-workspace .assistant-message.user .assistant-text { background: #f0edf7; border-color: #e9e3f1; }\n.assistant-workspace .assistant-text { line-height: 1.6; }\n.assistant-workspace .assistant-composer { border-top: 0; padding-top: 10px; }\n.assistant-workspace .assistant-composer-field { border-radius: 18px; box-shadow: 0 4px 20px #23273705; }\n.lkfr-dialog-overlay:has(> :is(.assistant-history-dialog, .assistant-delete-dialog)) { height: var(--assistant-dialog-viewport, 100dvh); }\n.lkfr-dialog.assistant-history-dialog { display: flex; flex-direction: column; width: min(100%, 480px); max-height: calc(var(--assistant-dialog-viewport, 100dvh) - 32px); min-height: min(480px, calc(var(--assistant-dialog-viewport, 100dvh) - 32px)); .assistant-history-body { margin-top: 16px; } button, input { font: inherit; } .assistant-history-delete { width: 44px; } }\n.lkfr-dialog.assistant-delete-dialog { width: min(100%, 420px); p { font-size: 14px; line-height: 1.6; overflow-wrap: anywhere; } }\n.lkfr-dialog:is(.assistant-history-dialog, .assistant-delete-dialog) { font-family: \"Cera Pro\", Arial, sans-serif; .lkfr-dialog-heading { display: flex; flex-shrink: 0; align-items: center; justify-content: space-between; gap: 12px; h2 { margin: 0; font-size: 22px; line-height: 1.2; } button { display: grid; place-items: center; flex-shrink: 0; width: 44px; height: 44px; border: 1px solid #e4e8ee; border-radius: 12px; background: white; color: #657085; font-size: 23px; cursor: pointer; } } }\n.assistant-workspace, .assistant-history-dialog { :is(button, input):focus-visible { outline: 3px solid #5365cc; outline-offset: -2px; } }\n@media (max-width: 1099px) {\n  .assistant-workspace { grid-template-columns: minmax(0, 1fr); }\n  .assistant-sidebar { display: none; }\n  .assistant-workspace .assistant-history-toggle { display: inline-flex; width: 44px; svg { width: 21px; height: 21px; } }\n}\n@media (max-width: 650px) {\n  .assistant-workspace .assistant-conversation-head { padding: 10px 12px; }\n  .assistant-workspace .assistant-context { margin: 0 12px 4px; padding: 9px 10px; }\n  .assistant-workspace .assistant-messages { padding: 18px 14px 12px; }\n  .assistant-intro-eyebrow { font-size: 9px; margin-bottom: 15px; letter-spacing: .08em; }\n  .assistant-workspace .assistant-intro h2 { font-size: 25px; }\n  .assistant-workspace .assistant-prompts { margin-top: 18px; margin-bottom: 14px; }\n  .assistant-workspace .assistant-prompts button { flex-wrap: nowrap; gap: 9px; min-height: 76px; padding: 11px; > span:nth-child(2) { flex-basis: auto; order: 0; } small { font-size: 10px; } }\n  .assistant-workspace .assistant-prompt-arrow { display: none; }\n  .assistant-intro-trust { gap: 8px; font-size: 9px; }\n  .assistant-workspace .assistant-composer { padding: 8px 12px max(10px, env(safe-area-inset-bottom)); }\n  .assistant-workspace .assistant-text { padding: 14px; }\n  .assistant-history-dialog .assistant-history-search input { font-size: 16px; }\n}\n@media (max-width: 650px) and (max-height: 720px) {\n  .assistant-workspace .assistant-messages { padding-top: 12px; }\n  .assistant-intro-eyebrow, .assistant-intro-trust { display: none; }\n  .assistant-workspace .assistant-prompts button { min-height: 62px; }\n  .assistant-workspace .assistant-intro h2 { font-size: 22px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
